import * as types from './types';

const INITIAL_STATE = {
  getNutritionStandards: {
    loading: false,
    data: [],
    errors: null,
  },
  
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.NUTRITIONSTANDARDSREPORT_GETNUTRITIONSTANDARDS_LOADING: {
      const { getNutritionStandards } = state;
      return {
        ...state,
        getNutritionStandards: {
          ...getNutritionStandards,
          loading: action.payload,
        },
      };
    }
    case types.NUTRITIONSTANDARDSREPORT_GETNUTRITIONSTANDARDS_SUCCESS: {
      const { getNutritionStandards } = state;
      return {
        ...state,
        getNutritionStandards: {
          ...getNutritionStandards,
          data: action.payload,
        },
      };
    }
    case types.NUTRITIONSTANDARDSREPORT_GETNUTRITIONSTANDARDS_ERROR: {
      const { getNutritionStandards } = state;
      return {
        ...state,
        getNutritionStandards: {
          ...getNutritionStandards,
          errors: action.payload,
        },
      };
    }

    
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/nutritionstandardsreport/state/reducer.js